import React from 'react';
import './index.scss';

interface ILoadingSpinnerProps {
  size?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

const LoadingSpinner = ({ size = 16, className, color = 'black', strokeWidth = 1, }: ILoadingSpinnerProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    role="status"
    aria-label="Loading"
    className={`loading-spinner ${className || ''}`}
    style={{ color }}
  >
    <path
      d="M8 1.5 A6.5 6.5 0 1 1 1.5 8"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

export default LoadingSpinner;
